import UploadField from './UploadField';

export default UploadField;
